'use strict';
module.exports = require('../../full/symbol/iterator');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/symbol/iterator.js
// module id = 614
// module chunks = 13